import { render, staticRenderFns } from "./PostStart.vue?vue&type=template&id=fc7ccc8e&scoped=true"
import script from "./PostStart.vue?vue&type=script&lang=js"
export * from "./PostStart.vue?vue&type=script&lang=js"
import style0 from "./PostStart.vue?vue&type=style&index=0&id=fc7ccc8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7ccc8e",
  null
  
)

export default component.exports